import { LOCALE_ID, NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { HomeModule } from './pages/home/home.module';
import { CompteModule } from './pages/compte/compte.module';
import { ConseilsModule } from './pages/conseils/conseils.module';
import { EquipementsModule } from './pages/equipements/equipements.module';
import { EquipementPageModule } from './pages/equipement/equipement-page.module';
import { DocumentsModule } from './pages/documents/documents.module';
import { ComponentsModule } from './components/components.module';
import { MesLogementsModule } from './pages/mes-logements/mes-logements.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ActualitesModule } from './pages/actualites/actualites.module';
import { ContactsModule } from './pages/contacts/contacts.module';
import { Rt2012Module } from './pages/rt2012/rt2012.module';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { NgxMatomoTrackerModule } from 'ngx-matomo-client';
import { NgxMatomoRouterModule } from 'ngx-matomo-client';
import { BrowserModule } from '@angular/platform-browser';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import {questionnaireMmodule} from "./pages/parcours-travaux/questionnaire/questionnaire.module";
import {callToActionModalModule} from "./pages/parcours-travaux/call-to-action-modal/call-to-action-modal.module";

registerLocaleData(localeFr);

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HomeModule,
        CompteModule,
        ActualitesModule,
        ConseilsModule,
        ContactsModule,
        EquipementsModule,
        EquipementPageModule,
        DocumentsModule,
        MesLogementsModule,
        Rt2012Module,
        NgbModule,
        CoreModule,
        ComponentsModule,
        FontAwesomeModule,
        RecaptchaV3Module,
        NgxMatomoTrackerModule.forRoot({
            siteId: environment.matomo.siteId,
            trackerUrl: environment.matomo.url,
            disabled: !environment.matomo.enabled
        }),
        NgxMatomoRouterModule,
        questionnaireMmodule,
        callToActionModalModule], providers: [
        { provide: LOCALE_ID, useValue: 'fr' },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule {
}
